export default __webpack_public_path__ + "static/media/LAS0830.34I-38575_-22599_0.c1e0925f.jpg";